import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {BaseSmartComponent} from './../base.component';
import {StateManager} from '@/state/stateManager';
import * as routerUtils from '@/utils/routerUtils';

import {MessageService} from '@/services/message.service';
import {SupplierService} from '@/services/supplier.service';

import {ISupplierModel, SupplierModel} from '@/models/supplier.models';

@Component({
    selector: 'supplier-add',
    templateUrl: './supplierAdd.template.html',
    host: {'class': 'supplier-add-component'}
})

export class SupplierAddComponent extends BaseSmartComponent implements OnInit {
    public model: Observable<ISupplierModel>;
    public showAlert: boolean = false;
    private _supplierListRoute: ActivatedRoute;
    private duplicateSupplier: ISupplierModel;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private supplierService: SupplierService,
        private state: StateManager,
        messageService: MessageService,
        private location: Location
        ) {
        super(messageService);
    }

    ngOnInit(): void {
        const self = this;

        self.model = self.state.getActiveSupplier();
        self.state.setActiveSupplier(new SupplierModel());

        self._supplierListRoute = routerUtils.getParentRoute(self.route);
    }

    public saveSupplier(newModel: ISupplierModel): void {
        const self = this;

        self.supplierService.updateSupplier(newModel)
            .then(() => {
                this.showAlert = false;
                self.router.navigate(['.'], { relativeTo: self._supplierListRoute });
            })
            .catch((err) => {
                this.showAlert = true;
                let error = err.error;
                this.duplicateSupplier = error.record;
            });
    }

    public cancel(): void {
        this.location.back();
    }

    public goToSupplier(): void {
        this.router.navigate([this.duplicateSupplier.id, 'Edit', 'Details'], { relativeTo: routerUtils.getParentRoute(this.route) });
    }

}
